import { IAuthorityDataService } from "../../core/authorities.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { Authorities } from "./authorities.component";
import { EditAuthority } from "./authority.edit.component";
import { Authority } from "./authority.component";

/**
 * This state displays all Authorities
 */
export const authoritiesState: Ng2StateDeclaration = {
    name: "app.settings.authorities",
    url: "/authorities",
    views: {
        "main-view@app": {
            component: Authorities
        }
    },
    resolve: {
        authorities: ["authorityDataService", (authorityDataService: IAuthorityDataService) => {
            return authorityDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Authority
 */
export const newAuthorityState: Ng2StateDeclaration = {
    name: "app.settings.authorities.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditAuthority
        }
    },
    resolve: {
        authority: function () {
            return <Nema.Crew.Model.Authority>{ Id: -1, Name: "", Active: true, SortTag: "", CompetenceRequirementCollections: null, Description: "" };
        },
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Authority
 */
export const editAuthorityState: Ng2StateDeclaration = {
    name: "app.settings.authorities.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditAuthority
        }
    },
    resolve: {
        authority: ["authorityDataService", "$stateParams", function (authorityDataService: IAuthorityDataService, $stateParams) {
            return authorityDataService.get($stateParams.id);
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Authority Details state
 */
export const authorityState: Ng2StateDeclaration = {
    name: "app.settings.authorities.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: Authority
        }
    },
    resolve: {
        authority: ["authorityDataService", "$stateParams", function (authorityDataService: IAuthorityDataService, $stateParams) {
            return authorityDataService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/authorities/authorities.states.ts